// Geteilte Stammdaten zu allen 11 Verfahren der Fritz Kamm AG.
// Wird vom Verfahren-Finder Result-PDF und vom Verfahren-Vergleich verwendet.
// Bilingual: DE (Default-Export `verfahren`) + EN (`verfahrenEn`).

export const verfahren = {
  "Verzinken": {
    schichtdicke: "5–25 µm",
    korrosionsschutz: "240–720 h Salzsprühnebel",
    materialien: ["Stahl", "Eisen", "Guss"],
    optik: "Silbrig-glänzend bis matt, transparent passiviert möglich",
    serientauglich: "Sehr hoch",
    anwendungen: ["Maschinenbau", "Baubeschläge", "Aussen­bauteile"],
    note: "Klassischer, wirtschaftlicher Korrosionsschutz für Stahl.",
  },
  "Trommelverzinken": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "240–600 h Salzsprühnebel",
    materialien: ["Stahl", "Eisen"],
    optik: "Gleichmäßig, leicht strukturiert",
    serientauglich: "Optimal für Großserien",
    anwendungen: ["Verbindungselemente", "Klein- und Schüttgut"],
    note: "Wirtschaftlichste Lösung für hohe Stückzahlen kleiner Teile.",
  },
  "Zink-Nickel": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "720–1'500+ h Salzsprühnebel",
    materialien: ["Stahl", "Hochfester Stahl"],
    optik: "Silbrig, matt bis glänzend",
    serientauglich: "Hoch",
    anwendungen: ["Automotive", "Hochbelastete Bauteile", "Brems- & Antriebsstrang"],
    note: "Premium-Korrosionsschutz, OEM-Standard in der Automobilindustrie.",
  },
  "Zink-Mangan-Phosphatieren": {
    schichtdicke: "3–15 µm",
    korrosionsschutz: "Verschleiß- und Reibungsoptimierung",
    materialien: ["Stahl"],
    optik: "Mattgrau bis schwarz",
    serientauglich: "Hoch",
    anwendungen: ["Hydraulik", "Werkzeuge", "Haftgrund für Beschichtungen"],
    note: "Verbessert Reibung & Verschleiß, klassischer Beschichtungs-Haftgrund.",
  },
  "CNS-Beizen": {
    schichtdicke: "Oberflächenbehandlung (kein Schichtauftrag)",
    korrosionsschutz: "Stellt natürliche Passivschicht wieder her",
    materialien: ["Edelstahl", "Cr-Ni-Stähle"],
    optik: "Mattgleich, ohne Anlauffarben & Zunder",
    serientauglich: "Hoch",
    anwendungen: ["Schweisskonstruktionen", "Apparatebau", "Lebensmittelindustrie"],
    note: "Reinigt und reaktiviert Edelstahl nach Schweiß- oder Wärmebehandlung.",
  },
  "CNS-Elektropolieren": {
    schichtdicke: "Glättung 1–5 µm Materialabtrag",
    korrosionsschutz: "Maximale Passivität, reinraumtauglich",
    materialien: ["Edelstahl 304/316/316L", "Duplex"],
    optik: "Hochglanz, Ra ≤ 0.4 µm möglich",
    serientauglich: "Mittel bis hoch",
    anwendungen: ["Medizintechnik", "Pharma", "Halbleiter", "Architektur"],
    note: "Hygienisch, glanzpoliert, korrosionsbeständigste Edelstahl-Veredelung.",
  },
  "Schleifen · Bürsten": {
    schichtdicke: "Mechanische Bearbeitung",
    korrosionsschutz: "Vorbereitung für Folgebeschichtung",
    materialien: ["Edelstahl", "Buntmetalle", "Aluminium"],
    optik: "Satiniert, gebürstet, dekorativ strukturiert",
    serientauglich: "Mittel",
    anwendungen: ["Architektur", "Fassaden", "Designteile", "Möbelbeschläge"],
    note: "Ästhetische Vorbereitung & finalisierte Sichtoberflächen.",
  },
  "Brünieren": {
    schichtdicke: "1–2 µm Konversionsschicht",
    korrosionsschutz: "Begrenzt — meist mit Öl konserviert",
    materialien: ["Stahl"],
    optik: "Tiefschwarz, dezent matt",
    serientauglich: "Hoch",
    anwendungen: ["Werkzeuge", "Optik", "Waffenteile", "Maschinenbauteile"],
    note: "Minimaler Schichtauftrag, maßhaltig, edler Look.",
  },
  "Vergolden": {
    schichtdicke: "0.1–25 µm",
    korrosionsschutz: "Sehr hoch, anlaufbeständig",
    materialien: ["Messing", "Kupfer", "Stahl (über Nickel)"],
    optik: "Hochglanz Gold, dekorativ oder funktional",
    serientauglich: "Mittel",
    anwendungen: ["Kontaktstellen", "Schmuck", "Möbelbeschläge", "HF-Technik"],
    note: "Funktional (Leitfähigkeit) und dekorativ — höchstwertige Veredelung.",
  },
  "Chemisch-Nickel": {
    schichtdicke: "5–50 µm, gleichmäßig auch in Hinterschnitten",
    korrosionsschutz: "Hoch, je nach Phosphorgehalt einstellbar",
    materialien: ["Stahl", "Aluminium", "Messing", "Guss"],
    optik: "Mattsilber bis halbglänzend",
    serientauglich: "Mittel bis hoch",
    anwendungen: ["Hydraulik", "Aluminium-Gehäuse", "Komplexe Geometrien"],
    note: "Stromlose Vernicklung — perfekt gleichmäßig, auch bei komplexen Teilen.",
  },
  "Galvanisch-Nickel": {
    schichtdicke: "5–40 µm",
    korrosionsschutz: "Hoch",
    materialien: ["Stahl", "Messing", "Kupfer"],
    optik: "Glänzend silbrig",
    serientauglich: "Hoch",
    anwendungen: ["Dekorative Bauteile", "Korrosionsschutz", "Haftgrund Gold"],
    note: "Klassische galvanische Vernicklung — dekorativ und funktional.",
  },
};

export const verfahrenEn = {
  "Verzinken": {
    schichtdicke: "5–25 µm",
    korrosionsschutz: "240–720 h salt spray",
    materialien: ["Steel", "Iron", "Cast iron"],
    optik: "Bright silver to matt; transparent passivation possible",
    serientauglich: "Very high",
    anwendungen: ["Mechanical engineering", "Building hardware", "Outdoor parts"],
    note: "Classic, economical corrosion protection for steel.",
  },
  "Trommelverzinken": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "240–600 h salt spray",
    materialien: ["Steel", "Iron"],
    optik: "Uniform, slightly textured",
    serientauglich: "Optimal for high volumes",
    anwendungen: ["Fasteners", "Small / bulk parts"],
    note: "Most economical solution for high quantities of small parts.",
  },
  "Zink-Nickel": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "720–1,500+ h salt spray",
    materialien: ["Steel", "High-strength steel"],
    optik: "Silver, matt to glossy",
    serientauglich: "High",
    anwendungen: ["Automotive", "High-load parts", "Brake & drivetrain"],
    note: "Premium corrosion protection, OEM standard in the automotive industry.",
  },
  "Zink-Mangan-Phosphatieren": {
    schichtdicke: "3–15 µm",
    korrosionsschutz: "Wear and friction optimisation",
    materialien: ["Steel"],
    optik: "Matt grey to black",
    serientauglich: "High",
    anwendungen: ["Hydraulics", "Tools", "Coating primer"],
    note: "Improves friction & wear; classic primer for further coatings.",
  },
  "CNS-Beizen": {
    schichtdicke: "Surface treatment (no build-up)",
    korrosionsschutz: "Restores natural passive layer",
    materialien: ["Stainless steel", "Cr-Ni alloys"],
    optik: "Uniform matt, no heat tint or scale",
    serientauglich: "High",
    anwendungen: ["Welded structures", "Process equipment", "Food industry"],
    note: "Cleans and reactivates stainless steel after welding or heat treatment.",
  },
  "CNS-Elektropolieren": {
    schichtdicke: "Smoothing — 1–5 µm material removal",
    korrosionsschutz: "Maximum passivity, cleanroom-grade",
    materialien: ["Stainless 304/316/316L", "Duplex"],
    optik: "High gloss, Ra ≤ 0.4 µm achievable",
    serientauglich: "Medium to high",
    anwendungen: ["Medical", "Pharma", "Semiconductor", "Architecture"],
    note: "Hygienic, mirror-polished, the most corrosion-resistant stainless finish.",
  },
  "Schleifen · Bürsten": {
    schichtdicke: "Mechanical processing",
    korrosionsschutz: "Preparation for subsequent coatings",
    materialien: ["Stainless steel", "Non-ferrous metals", "Aluminium"],
    optik: "Satin, brushed, decoratively textured",
    serientauglich: "Medium",
    anwendungen: ["Architecture", "Façades", "Design parts", "Furniture hardware"],
    note: "Aesthetic preparation & finished visible surfaces.",
  },
  "Brünieren": {
    schichtdicke: "1–2 µm conversion layer",
    korrosionsschutz: "Limited — typically oil-preserved",
    materialien: ["Steel"],
    optik: "Deep black, subtle matt",
    serientauglich: "High",
    anwendungen: ["Tools", "Optics", "Firearm parts", "Machine components"],
    note: "Minimal build-up, dimensionally stable, refined look.",
  },
  "Vergolden": {
    schichtdicke: "0.1–25 µm",
    korrosionsschutz: "Very high, tarnish-resistant",
    materialien: ["Brass", "Copper", "Steel (over nickel)"],
    optik: "High-gloss gold — decorative or functional",
    serientauglich: "Medium",
    anwendungen: ["Contacts", "Jewellery", "Furniture hardware", "RF technology"],
    note: "Functional (conductivity) and decorative — highest-end finish.",
  },
  "Chemisch-Nickel": {
    schichtdicke: "5–50 µm, uniform even in undercuts",
    korrosionsschutz: "High, adjustable via phosphorus content",
    materialien: ["Steel", "Aluminium", "Brass", "Cast iron"],
    optik: "Matt silver to semi-gloss",
    serientauglich: "Medium to high",
    anwendungen: ["Hydraulics", "Aluminium housings", "Complex geometries"],
    note: "Electroless nickel plating — perfectly uniform even on complex parts.",
  },
  "Galvanisch-Nickel": {
    schichtdicke: "5–40 µm",
    korrosionsschutz: "High",
    materialien: ["Steel", "Brass", "Copper"],
    optik: "Glossy silver",
    serientauglich: "High",
    anwendungen: ["Decorative parts", "Corrosion protection", "Gold base coat"],
    note: "Classic electrolytic nickel plating — decorative and functional.",
  },
};

export const verfahrenList = Object.keys(verfahren);

export const verfahrenFr = {
  "Verzinken": {
    schichtdicke: "5–25 µm",
    korrosionsschutz: "240–720 h brouillard salin",
    materialien: ["Acier", "Fer", "Fonte"],
    optik: "Argent brillant à mat ; passivation transparente possible",
    serientauglich: "Très élevée",
    anwendungen: ["Construction mécanique", "Quincaillerie", "Pièces extérieures"],
    note: "Protection anti-corrosion classique et économique pour l'acier.",
  },
  "Trommelverzinken": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "240–600 h brouillard salin",
    materialien: ["Acier", "Fer"],
    optik: "Uniforme, légèrement structuré",
    serientauglich: "Optimale pour grandes séries",
    anwendungen: ["Visserie", "Petites pièces / vrac"],
    note: "Solution la plus économique pour de grandes quantités de petites pièces.",
  },
  "Zink-Nickel": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "720–1500+ h brouillard salin",
    materialien: ["Acier", "Acier haute résistance"],
    optik: "Argent, mat à brillant",
    serientauglich: "Élevée",
    anwendungen: ["Automobile", "Pièces fortement sollicitées", "Freinage & transmission"],
    note: "Protection anti-corrosion premium, standard OEM dans l'automobile.",
  },
  "Zink-Mangan-Phosphatieren": {
    schichtdicke: "3–15 µm",
    korrosionsschutz: "Optimisation usure et frottement",
    materialien: ["Acier"],
    optik: "Gris mat à noir",
    serientauglich: "Élevée",
    anwendungen: ["Hydraulique", "Outillage", "Base d'accrochage"],
    note: "Améliore frottement & usure ; base d'accrochage classique pour revêtements.",
  },
  "CNS-Beizen": {
    schichtdicke: "Traitement de surface (sans dépôt)",
    korrosionsschutz: "Restitue la couche passive naturelle",
    materialien: ["Acier inoxydable", "Alliages Cr-Ni"],
    optik: "Mat uniforme, sans coloration ni calamine",
    serientauglich: "Élevée",
    anwendungen: ["Constructions soudées", "Équipements", "Industrie agroalimentaire"],
    note: "Nettoie et réactive l'inox après soudure ou traitement thermique.",
  },
  "CNS-Elektropolieren": {
    schichtdicke: "Lissage — enlèvement 1–5 µm",
    korrosionsschutz: "Passivité maximale, compatible salle blanche",
    materialien: ["Inox 304/316/316L", "Duplex"],
    optik: "Haute brillance, Ra ≤ 0,4 µm possible",
    serientauglich: "Moyenne à élevée",
    anwendungen: ["Médical", "Pharmacie", "Semi-conducteurs", "Architecture"],
    note: "Hygiénique, miroir, la finition inox la plus résistante à la corrosion.",
  },
  "Schleifen · Bürsten": {
    schichtdicke: "Traitement mécanique",
    korrosionsschutz: "Préparation pour finition ultérieure",
    materialien: ["Inox", "Métaux non ferreux", "Aluminium"],
    optik: "Satiné, brossé, structuré décoratif",
    serientauglich: "Moyenne",
    anwendungen: ["Architecture", "Façades", "Pièces design", "Quincaillerie de meuble"],
    note: "Préparation esthétique & finitions visibles finalisées.",
  },
  "Brünieren": {
    schichtdicke: "Couche de conversion 1–2 µm",
    korrosionsschutz: "Limitée — généralement protégée à l'huile",
    materialien: ["Acier"],
    optik: "Noir profond, mat discret",
    serientauglich: "Élevée",
    anwendungen: ["Outillage", "Optique", "Pièces d'arme", "Mécanique"],
    note: "Dépôt minimal, dimensions stables, aspect raffiné.",
  },
  "Vergolden": {
    schichtdicke: "0,1–25 µm",
    korrosionsschutz: "Très élevée, anti-ternissement",
    materialien: ["Laiton", "Cuivre", "Acier (sur nickel)"],
    optik: "Or haute brillance — décoratif ou fonctionnel",
    serientauglich: "Moyenne",
    anwendungen: ["Contacts", "Bijouterie", "Quincaillerie de meuble", "HF"],
    note: "Fonctionnelle (conductivité) et décorative — la finition haut de gamme.",
  },
  "Chemisch-Nickel": {
    schichtdicke: "5–50 µm, uniforme même en contre-dépouille",
    korrosionsschutz: "Élevée, ajustable selon la teneur en phosphore",
    materialien: ["Acier", "Aluminium", "Laiton", "Fonte"],
    optik: "Argent mat à semi-brillant",
    serientauglich: "Moyenne à élevée",
    anwendungen: ["Hydraulique", "Boîtiers aluminium", "Géométries complexes"],
    note: "Nickelage chimique — parfaitement uniforme, même sur pièces complexes.",
  },
  "Galvanisch-Nickel": {
    schichtdicke: "5–40 µm",
    korrosionsschutz: "Élevée",
    materialien: ["Acier", "Laiton", "Cuivre"],
    optik: "Argent brillant",
    serientauglich: "Élevée",
    anwendungen: ["Pièces décoratives", "Anti-corrosion", "Sous-couche pour dorure"],
    note: "Nickelage électrolytique classique — décoratif et fonctionnel.",
  },
};

export const verfahrenIt = {
  "Verzinken": {
    schichtdicke: "5–25 µm",
    korrosionsschutz: "240–720 h nebbia salina",
    materialien: ["Acciaio", "Ferro", "Ghisa"],
    optik: "Argento lucido o opaco; passivazione trasparente possibile",
    serientauglich: "Molto elevata",
    anwendungen: ["Costruzione meccanica", "Ferramenta", "Componenti per esterni"],
    note: "Protezione anticorrosiva classica ed economica per l'acciaio.",
  },
  "Trommelverzinken": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "240–600 h nebbia salina",
    materialien: ["Acciaio", "Ferro"],
    optik: "Uniforme, leggermente strutturato",
    serientauglich: "Ottima per grandi serie",
    anwendungen: ["Viteria", "Minuteria / sfuso"],
    note: "Soluzione più economica per grandi quantità di pezzi piccoli.",
  },
  "Zink-Nickel": {
    schichtdicke: "5–15 µm",
    korrosionsschutz: "720–1500+ h nebbia salina",
    materialien: ["Acciaio", "Acciai ad alta resistenza"],
    optik: "Argento, da opaco a brillante",
    serientauglich: "Elevata",
    anwendungen: ["Automotive", "Componenti ad alto carico", "Freni & trasmissione"],
    note: "Protezione anticorrosiva premium, standard OEM nell'automotive.",
  },
  "Zink-Mangan-Phosphatieren": {
    schichtdicke: "3–15 µm",
    korrosionsschutz: "Ottimizzazione attrito e usura",
    materialien: ["Acciaio"],
    optik: "Da grigio opaco a nero",
    serientauglich: "Elevata",
    anwendungen: ["Idraulica", "Utensili", "Base d'aggrappo"],
    note: "Migliora attrito e usura; classica base d'aggrappo per rivestimenti.",
  },
  "CNS-Beizen": {
    schichtdicke: "Trattamento di superficie (senza deposito)",
    korrosionsschutz: "Ripristina lo strato passivo naturale",
    materialien: ["Acciaio inox", "Leghe Cr-Ni"],
    optik: "Opaco uniforme, senza ossidazioni né calamine",
    serientauglich: "Elevata",
    anwendungen: ["Costruzioni saldate", "Impiantistica", "Industria alimentare"],
    note: "Pulisce e riattiva l'inox dopo saldatura o trattamento termico.",
  },
  "CNS-Elektropolieren": {
    schichtdicke: "Lisciatura — asportazione 1–5 µm",
    korrosionsschutz: "Massima passività, idonea camera bianca",
    materialien: ["Inox 304/316/316L", "Duplex"],
    optik: "Alta brillantezza, Ra ≤ 0,4 µm possibile",
    serientauglich: "Da media ad elevata",
    anwendungen: ["Medicale", "Farmaceutico", "Semiconduttori", "Architettura"],
    note: "Igienica, a specchio, la finitura inox più resistente alla corrosione.",
  },
  "Schleifen · Bürsten": {
    schichtdicke: "Trattamento meccanico",
    korrosionsschutz: "Preparazione per finiture successive",
    materialien: ["Inox", "Metalli non ferrosi", "Alluminio"],
    optik: "Satinato, spazzolato, struttura decorativa",
    serientauglich: "Media",
    anwendungen: ["Architettura", "Facciate", "Componenti design", "Ferramenta arredo"],
    note: "Preparazione estetica e finiture a vista finalizzate.",
  },
  "Brünieren": {
    schichtdicke: "Strato di conversione 1–2 µm",
    korrosionsschutz: "Limitata — solitamente protetta con olio",
    materialien: ["Acciaio"],
    optik: "Nero profondo, opaco discreto",
    serientauglich: "Elevata",
    anwendungen: ["Utensili", "Ottica", "Componenti d'arma", "Meccanica"],
    note: "Deposito minimo, dimensioni stabili, aspetto raffinato.",
  },
  "Vergolden": {
    schichtdicke: "0,1–25 µm",
    korrosionsschutz: "Molto elevata, anti-ossidante",
    materialien: ["Ottone", "Rame", "Acciaio (su nichel)"],
    optik: "Oro alta brillantezza — decorativo o funzionale",
    serientauglich: "Media",
    anwendungen: ["Contatti", "Gioielleria", "Ferramenta arredo", "RF"],
    note: "Funzionale (conduttività) e decorativa — la finitura premium.",
  },
  "Chemisch-Nickel": {
    schichtdicke: "5–50 µm, uniforme anche su sottosquadri",
    korrosionsschutz: "Elevata, regolabile via contenuto di fosforo",
    materialien: ["Acciaio", "Alluminio", "Ottone", "Ghisa"],
    optik: "Argento da opaco a semi-lucido",
    serientauglich: "Da media ad elevata",
    anwendungen: ["Idraulica", "Scocche in alluminio", "Geometrie complesse"],
    note: "Nichelatura chimica — perfettamente uniforme anche su pezzi complessi.",
  },
  "Galvanisch-Nickel": {
    schichtdicke: "5–40 µm",
    korrosionsschutz: "Elevata",
    materialien: ["Acciaio", "Ottone", "Rame"],
    optik: "Argento lucido",
    serientauglich: "Elevata",
    anwendungen: ["Componenti decorativi", "Anticorrosione", "Sottostrato per doratura"],
    note: "Nichelatura galvanica classica — decorativa e funzionale.",
  },
};
